var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#72383D;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17327 -5816)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 60,
    rx: 4,
    transform: "translate(17327 5816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.178,3,2,21.16H8.053V37.3H16.43V26.128h11.5V37.3H36.3V21.16h6.053Z",
    transform: "translate(17334.508 5825.956)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProperty);
export default __webpack_public_path__ + "static/media/icon_property.661732ac50f1f12bf493f8ce8a0e4dcb.svg";
export { ForwardRef as ReactComponent };